import React, { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";
import { api } from "../../../services/Main/Api";
import { getCondoId } from "../../../services/Main/AuthStorage";

import DocSignList from "./DocSignList";
import SignaturePaywall from "./SignaturePaywall";

const DocSignGate = () => {
    const [loading, setLoading] = useState(true);
    const [enabled, setEnabled] = useState(false);

    const fetchStatus = async () => {
        try {
            // 🔧 ajuste este endpoint para o que você tiver
            const res = await api.get(`/condo/${getCondoId()}`, { params: { condo_id: getCondoId() } });
            const data = res.data;
            console.log(data);
            setEnabled(Boolean(res.data?.enabled_sign));
        } catch (e) {
            // se der erro, assume desativado e mostra o paywall
            setEnabled(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStatus();
    }, []);

    if (loading) {
        return (
            <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
                <CircularProgress />
            </Box>
        );
    }

    return enabled ? (
        <DocSignList />
    ) : (
        <SignaturePaywall onActivated={fetchStatus} />
    );
};

export default DocSignGate;
